/**
 * Matches server getEffectiveUserRole / requireAdmin semantics for UI gating.
 */
export function getEffectiveUserRole(user) {
  if (!user) return 'user';

  const adminFlag = user.isAdmin;
  const truthyAdmin =
    adminFlag === true ||
    adminFlag === 1 ||
    adminFlag === '1' ||
    (typeof adminFlag === 'string' && adminFlag.toLowerCase() === 'true');

  const roleRaw = (user.role != null ? String(user.role) : '').toLowerCase().trim();

  if (truthyAdmin || roleRaw === 'admin' || roleRaw === 'administrator' || roleRaw === 'superadmin') {
    return 'admin';
  }
  if (roleRaw === 'moderator') return 'moderator';
  if (roleRaw === 'vendor') return 'vendor';
  return 'user';
}

export function isBookForPawsAdmin(user) {
  return getEffectiveUserRole(user) === 'admin';
}
